export class Document {
    constructor(document) {
        this.document_type_external_id = '';
        this.document_category_external_id = '';
        this.selected = '';
        this.uploader_status = {
            uploading: false
        };
        this.uploaded_files = [];
        this.entities = [];
        this.values = [];

        if (!!document) {
            this.setData(document);
        }
    }

    setData(data) {
        let doc = this;
        let data_keys = Object.keys(data);
        data_keys.map(f => {
            if (f == 'values') {
                this[f] = data[f].map(value => new DocumentValues(value));
            }
            if (f == 'metadata' && !!data[f].card_details.elements) {
                Object.values(data[f].card_details.elements).map(element => {
                    let value = new DocumentValues();
                    value.field_name = element.id;
                    value.attribute = element.attribute;
                    doc.values.push(value);
                });
            } else {
                this[f] = data[f];
            }
        });
    }

}

export class DocumentValues {
    constructor(value) {
        this.field_name = '';
        this.field_value = '';
        this.attribute = '';

        if (!!value) {
            this.setData(value);
        }
    }

    setData(data) {
        let data_keys = Object.keys(data);
        data_keys.map(f => {
            this[f] = data[f]
        });
    }
}